import * as React from 'react'
import { useMemo } from 'react'
import {
  BulkActionErrorDescription,
  BulkActionErrorSummary,
} from '../../BulkActionErrors'
import { bulkActionErrors } from '../../constants'
import { ErrorSummary } from './typings'
import { ENTITY_TYPES } from '@sales-center/common'

export const RowErrors: React.FC<{
  loading: boolean
  errorSummary: ErrorSummary
  entityType: ENTITY_TYPES
}> = (props) => {
  const {
    errorSummary: {
      count,
      hasAlreadyClosed,
      hasWrongBranch,
      hasServices,
      hasLocationMatches,
      hasOpen,
    },
    entityType,
  } = props

  const description = useMemo(() => {
    const noun = count === 1 ? 'record' : 'records'
    return `${count} ${noun} found that cannot be updated.`
  }, [count])

  return (
    <>
      {count > 0 && <BulkActionErrorSummary description={description} />}

      {hasOpen && (
        <BulkActionErrorDescription detail={bulkActionErrors.reassign.open} />
      )}

      {hasAlreadyClosed && (
        <BulkActionErrorDescription detail={bulkActionErrors.reassign.closed} />
      )}

      {(hasWrongBranch || hasServices || hasLocationMatches) && (
        <BulkActionErrorDescription
          detail={
            entityType == ENTITY_TYPES.Lead
              ? bulkActionErrors.reassign.crossBranch
              : bulkActionErrors.reassign.branch
          }
        />
      )}
    </>
  )
}
RowErrors.displayName = 'RowErrors'

export default React.memo(RowErrors)
